import React from "react";
import SummarizationCard from "../components/SummarizationCard";

const Summarization = () => {
    return <SummarizationCard />;
}

export default Summarization;